import { Images, LogoImages, QuestionGroup, QuestionType, ScenarioStep, Steps, Translatable } from '../state/interfaces'

export const provinces: ScenarioStep = {
  id: Steps.PROVINCE,
  group: QuestionGroup.DEFAULT,
  question: 'province_question',
  tip: 'province_tip',
  answerPlaceholder: 'province_answerPlaceholder',
  type: QuestionType.MIXED_CHOICE_WITH_PILLS_LARGE_PROVINCE,
  answers: [
    {
      id: 'alberta',
      text: 'province_alberta' as Translatable,
      metadata: { initials: 'AB', image: LogoImages.ALBERTA },
    },
    {
      id: 'british-columbia',
      text: 'province_british-columbia',
      metadata: { initials: 'BC', image: LogoImages.BRITISH_COLUMBIA },
    },
    { id: 'manitoba', text: 'province_manitoba', metadata: { initials: 'MB', image: LogoImages.MANITOBA } },
    {
      id: 'new-brunswick',
      text: 'province_new-brunswick',
      metadata: { initials: 'NB', image: LogoImages.NEW_BRUNSWICK },
    },
    {
      id: 'newfoundland-labrador',
      text: 'province_newfoundland-labrador',
      metadata: { initials: 'NL', image: LogoImages.NEWFOUNDLAND_AND_LABRADOR },
    },
    {
      id: 'northwest-territories',
      text: 'province_northwest-territories',
      metadata: { initials: 'NT', image: LogoImages.NORTHWEST_TERRITORIES },
    },
    {
      id: 'nova-scotia',
      text: 'province_nova-scotia',
      metadata: { initials: 'NS', image: LogoImages.NOVA_SCOTIA },
    },
    { id: 'nunavut', text: 'province_nunavut', metadata: { initials: 'NU', image: LogoImages.NUNAVUT } },
    { id: 'ontario', text: 'province_ontario', metadata: { initials: 'ON', image: LogoImages.ONTARIO } },
    {
      id: 'prince-edward',
      text: 'province_prince-edward',
      metadata: { initials: 'PE', image: LogoImages.PRINCE_EDWARD_ISLAND },
    },
    { id: 'quebec', text: 'province_quebec', metadata: { initials: 'QC', image: LogoImages.QUEBEC } },
    {
      id: 'saskatchewan',
      text: 'province_saskatchewan',
      metadata: { initials: 'SK', image: LogoImages.SASKATCHEWAN },
    },
    { id: 'yukon', text: 'province_yukon', metadata: { initials: 'YT', image: LogoImages.YUKON } },
  ],
}

export const providers: ScenarioStep = {
  id: Steps.CURRENT_PROVIDER,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.MIXED_CHOICE_WITH_PILLS_LARGE,
  answers: [],
}

export const selectCurrentProvider: ScenarioStep = {
  id: Steps.SELECT_CURRENT_PROVIDER,
  group: QuestionGroup.DEFAULT,
  question: 'select-current-provider_question',
  tip: 'select-current-provider_tip',
  type: QuestionType.INPUT_AUTOCOMPLETE,
  answerPlaceholder: 'select-current-provider_answerPlaceholder',
  answers: [],
}

export const addressLocation: ScenarioStep = {
  id: Steps.ADDRESS_LOCATION,
  group: QuestionGroup.DEFAULT,
  question: 'address-location_question',
  type: QuestionType.GOOGLE_AUTOCOMPLETE,
  answerPlaceholder: 'address-location_answerPlaceholder',
  next: Steps.START_RATING,
  answers: [],
  metadata: { grandImage: Images.ADDRESS_LOCATION },
}

export const internetSpeed: ScenarioStep = {
  id: Steps.INTERNET_SPEED,
  group: QuestionGroup.ALERT,
  question: 'internet-speed_question',
  tip: 'internet-speed_tip',
  type: QuestionType.CHOICE_AS_PILLS,
  answerPlaceholder: 'internet-speed_answerPlaceholder',
  answers: [],
}

export const postalCodeInternet: ScenarioStep = {
  id: Steps.POSTAL_CODE_INTERNET,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.POSTAL_CODE_INTERNET,
  answers: [],
}

export const startRating: ScenarioStep = {
  id: Steps.START_RATING,
  group: QuestionGroup.DEFAULT,
  tip: 'start-rating_tip',
  type: QuestionType.CHOICE_AS_MAIN_PILL,
  answers: [
    {
      id: 'start',
      text: 'common_start',
    },
  ],
  metadata: { grandImage: Images.REVIEW_3 },
}

export const confirm: ScenarioStep = {
  id: Steps.CONFIRM,
  group: QuestionGroup.DEFAULT,
  question: 'confirm_question',
  type: QuestionType.RADIO_CONFIRM,
  answers: [],
}

export const emailAddress: ScenarioStep = {
  id: Steps.EMAIL_ADDRESS,
  group: QuestionGroup.DEFAULT,
  question: 'email-address_question',
  type: QuestionType.EMAIL,
  answerPlaceholder: 'email-address_answerPlaceholder',
  answers: [],
}

export const thanks: ScenarioStep = {
  id: Steps.THANKS,
  group: QuestionGroup.DEFAULT,
  question: 'thanks_question',
  tip: 'thanks_tip',
  type: QuestionType.CHOICE_AS_MAIN_PILL,
  next: Steps.DONE,
  answers: [
    {
      id: 'close',
      text: 'common_close',
    },
  ],
  metadata: { grandImage: Images.REVIEW_11 },
}

export const firstName: ScenarioStep = {
  id: Steps.FIRST_NAME,
  group: QuestionGroup.DEFAULT,
  question: 'first-name_question',
  type: QuestionType.INPUT_DEFAULT,
  answerPlaceholder: 'first-name_answerPlaceholder',
  next: Steps.LAST_NAME,
  answers: [],
  metadata: { grandImage: Images.FIRST_NAME, inputType: 'name' },
}

export const lastName: ScenarioStep = {
  id: Steps.LAST_NAME,
  group: QuestionGroup.DEFAULT,
  question: 'last-name_question',
  type: QuestionType.INPUT_DEFAULT,
  answerPlaceholder: 'last-name_answerPlaceholder',
  next: Steps.PHONE_NUMBER,
  answers: [],
  metadata: { grandImage: Images.LAST_NAME, inputType: 'name' },
}

export const phoneNumber: ScenarioStep = {
  id: Steps.PHONE_NUMBER,
  group: QuestionGroup.DEFAULT,
  question: 'phone-number_question',
  type: QuestionType.INPUT_PHONE,
  answerPlaceholder: 'phone-number_answerPlaceholder',
  answers: [],
  metadata: { grandImage: Images.LEAD_3 },
}

export const decisionMobileInternet: ScenarioStep = {
  id: Steps.DECISION_MOBILE_INTERNET,
  group: QuestionGroup.DECISION,
  question: 'decision-mobile-internet_question',
  tip: 'decision-mobile-internet_tip',
  type: QuestionType.MIXED_CHOICE_WITH_PILLS_LARGE_DECISION,
  next: Steps.DONE,
  answers: [
    {
      id: 'mobile',
      text: 'cell-phone-plan',
      metadata: { image: Images.CELL_PHONE_STATE_1, imageSelected: Images.CELL_PHONE_STATE_2 },
    },
    {
      id: 'internet',
      text: 'home-internet-plan',
      metadata: { image: Images.INTERNET_STATE_1, imageSelected: Images.INTERNET_STATE_2 },
    },
  ],
}

// export const decisionAlertCommonPriceDrop: ScenarioStep = {
//   id: Steps.DECISION_ALERT_COMMON_PRICE_DROP,
//   group: QuestionGroup.DECISION_ALERT,
//   question: 'decision-alert-common-price-drop_question',
//   tip: 'decision-alert-common-price-drop_tip',
//   type: QuestionType.MIXED_CHOICE_WITH_PILLS_LARGE_DECISION,
//   next: Steps.DONE,
//   answers: [
//     {
//       id: 'price-drop',
//       text: 'price-drop-main-text',
//       metadata: {
//         image: Images.ALERT_YOUR_PLAN,
//         imageSelected: Images.ALERT_YOUR_PLAN_LOADED,
//         secondaryLabel: 'price-drop-secondary-text',
//       },
//     },
//     {
//       id: 'alert-search',
//       text: 'alert-search-main-text',
//       metadata: {
//         image: Images.ALERT_SEARCH,
//         imageSelected: Images.ALERT_SEARCH_LOADED,
//         secondaryLabel: 'alert-search-secondary-text',
//       },
//     },
//   ],
// }

export const decisionAlertCommonPriceDrop: ScenarioStep = {
  id: Steps.DECISION_ALERT_COMMON_PRICE_DROP,
  group: QuestionGroup.DECISION_ALERT,
  question: 'decision-alert-common-price-drop_question',
  tip: 'decision-alert-common-price-drop_tip',
  type: QuestionType.CHOICE_AS_PILLS_EXTRA_LARGE,
  next: Steps.DONE,
  answers: [
    {
      id: 'price-drop',
      text: 'price-drop-main-text',
      // metadata: {
      //   image: Images.ALERT_YOUR_PLAN,
      //   imageSelected: Images.ALERT_YOUR_PLAN_LOADED,
      //   secondaryLabel: 'price-drop-secondary-text',
      // },
    },
    {
      id: 'alert-search',
      text: 'alert-search-main-text',
      // metadata: {
      //   image: Images.ALERT_SEARCH,
      //   imageSelected: Images.ALERT_SEARCH_LOADED,
      //   secondaryLabel: 'alert-search-secondary-text',
      // },
    },
  ],
}

export const phoneResidential: ScenarioStep = {
  id: Steps.PHONE_RESIDENTIAL,
  next: Steps.INSTALLATION_DATE_PICKER,
  group: QuestionGroup.LEAD,
  question: 'phone-residential_question',
  tip: 'phone-residential_tip',
  type: QuestionType.INPUT_PHONE,
  answerPlaceholder: 'phone-residential_answerPlaceholder',
  answers: [],
}
